import { alpha } from '@mui/material/styles';
import { palette } from '@app/palette';

// Everything derives from the app palette so the flow matches the rest of Athena.
export const tokens = {
  title: palette.primary.main,
  label: palette.primary.dark, // small uppercase labels — darker teal keeps them readable at 12–14px
  textPrimary: '#050504', // the theme's body text color — used for all copy in the flow
  icon: palette.primary.main,
  border: alpha(palette.primary.main, 0.2),
  borderSubtle: alpha(palette.primary.main, 0.12),
  surface: alpha(palette.primary.main, 0.05),
  track: alpha(palette.primary.main, 0.15),
  warningBg: alpha(palette.warning.main, 0.08),
  warningBorder: palette.warning.light,
  warningText: palette.warning.dark,
};
